import TextHighlighter from 'marketing/utils/TextHighlighter';
import { trackEvent } from '@99designs/common/utils/platform';
import { replaceKeys } from 'marketing/utils/internationalisation-utils';
import { scrollToElement } from 'common/utils/scroll';

export default class CategorySearch {
    constructor({ searcher, onChange = () => {} }) {
        this.searchBox = document.querySelector('[data-search-field]');
        this.searchButtons = document.querySelectorAll('[data-search-button]');
        this.resultsCounter = document.querySelector('[data-search-results-count]');
        this.resultsElement = document.querySelector('[data-search-results]');
        this.highlighter = new TextHighlighter();
        this.searcher = searcher;
        this.trackTimeout = null;
        this.trackSearch = this.trackSearch.bind(this);
        this.onChange = onChange;

        this.searchBox.addEventListener('keyup', this.handleSearchBoxKeyUp.bind(this));

        Array.from(this.searchButtons).forEach(button => {
            button.addEventListener('click', this.handleSearchButtonClick.bind(this));
        });
    }

    updateResultsCounter(results, searchTerm) {
        const msgString =
            results.length > 1
                ? window.categoriesLang.resultsCountPlural
                : window.categoriesLang.resultsCountSingular;

        this.resultsCounter.innerHTML = replaceKeys(msgString, {
            count: results.length,
            searchTerm: `<span data-categories-chameleon-element>${this.escape(searchTerm)}</span>`,
        });
    }

    escape(string) {
        const div = document.createElement('div');
        div.appendChild(document.createTextNode(string));
        return div.innerHTML;
    }

    highlightMatches(result, matchingTerms) {
        const titleNode = result.node.querySelector('[data-category-title]');
        titleNode.innerHTML = result.title;
        titleNode.innerHTML = this.highlighter.highlight(
            result.title,
            matchingTerms,
            'data-categories-chameleon-element'
        );

        return result.node;
    }

    updateResults(results, matchingTerms) {
        this.resultsElement.textContent = '';
        this.appendBorderOverride();

        results.forEach(result => {
            this.resultsElement.appendChild(this.highlightMatches(result, matchingTerms));
        });

        this.preloadModalImages(results.map(result => result.key));
    }

    preloadModalImages(categoryKeys) {
        categoryKeys.forEach(categoryKey => {
            const image = document.querySelector(
                `[data-fullscreen-overlay-id="categories-modal-${categoryKey}"] img[data-src]`
            );
            if (image) {
                image.src = image.getAttribute('data-src');
            }
        });
    }

    appendBorderOverride(resultsElement) {
        const borderOverrideSpan = document.createElement('span');
        borderOverrideSpan.className = 'categories-bordered-tiles__border-override';
        this.resultsElement.appendChild(borderOverrideSpan);
    }

    search() {
        const searchTerm = this.searchBox.value;
        const searchResult = this.searcher.search(searchTerm);

        searchResult.results = this.promoteHighlightedResults(searchResult.results);
        this.updateResultsCounter(searchResult.results, searchTerm);
        this.updateResults(searchResult.results, searchResult.matchingTerms);

        this.trackSearch(searchResult.results);
        this.onChange();
    }

    promoteHighlightedResults(searchResult) {
        const partitionedResults = searchResult.reduce(
            (accumulator, currentResult) => {
                currentResult.node.hasAttribute('data-category-highlighted')
                    ? accumulator.highlighted.push(currentResult)
                    : accumulator.notHighlighted.push(currentResult);
                return accumulator;
            },
            { highlighted: [], notHighlighted: [] }
        );

        return partitionedResults.highlighted.concat(partitionedResults.notHighlighted);
    }

    trackSearch(results) {
        if (this.trackTimeout) {
            clearTimeout(this.trackTimeout);
        }

        this.trackTimeout = setTimeout(() => {
            if (this.searchBox.value) {
                trackEvent('Performed Search On Categories Page', {
                    searchTerm: this.searchBox.value,
                    noOfSearchResults: results.length,
                });
            }
        }, 1000);
    }

    scrollToSearchResults() {
        scrollToElement(this.resultsCounter, 30, 500);
    }

    handleSearchBoxKeyUp(e) {
        if (this.searchBox.value !== '' && e.keyCode === 13) {
            this.scrollToSearchResults();
        } else {
            this.search();
        }
    }

    handleSearchButtonClick(e) {
        if (this.searchBox.value !== '') {
            this.scrollToSearchResults();
        }
    }
}
